import React from "react";

import { DateTime } from "luxon";

import { V2 } from "../../Api";
import { formatDateLocal, formatName, formatPhone, formatTimeLocal } from "../../Utilities";

import "../../surgeryschedule.css";
import WCASLogo from "../../images/wcas_logo_trim_small.png"

interface ISurgeryDayScheduleViewState {
    error?: string;
    isLoading: boolean;

    operations: any[];

    endDate: DateTime;
    startDate: DateTime;

    location: string;
    status: string;
    type: string;
}

class SurgeryDayScheduleView extends React.Component<{}, ISurgeryDayScheduleViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            isLoading: true,

            operations: [],

            endDate: DateTime.local(),
            startDate: DateTime.local(),

            location: "",
            status: "",
            type: "",
        };

        this.handleMessage = this.handleMessage.bind(this);
        this.loadData = this.loadData.bind(this);

        this.renderSurgeryList = this.renderSurgeryList.bind(this);
    }

    public componentDidMount() {
        // Request report data from main window
        window.addEventListener("message", this.handleMessage, false);
        window.opener.postMessage({ action: "surgery_schedule_request" }, "*");
    }

    public componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }

    public render() {
        if (this.state.error) {
            return <div className="error-box">{this.state.error}</div>;
        }

        if (this.state.isLoading) {
            return <div className="spinner spinner-full spinner-full-root lds-dual-ring-big" />;
        }

        return (
            <div className="page-flow-root page-size-letter">
                <div className="print-page-pseudo">
                    <table className="table-print table-dense table-schedule nohover">
                        <thead>
                            <tr className="thead-page-header thead-page-header-first">
                                <td colSpan={5}>
                                    <img alt="WCAS Logo" className="logo" src={WCASLogo} />
                                </td>
                                <td className="page-header-name">
                                    {
                                        (this.state.type === "!office" || this.state.type === "")
                                            ? <h2>Surgery Schedule</h2>
                                            : <h2>Office Surgery Schedule</h2>
                                    }
                                </td>
                            </tr>
                            <tr className="thead-page-header thead-page-header-second">
                                <td colSpan={7}>Date: {formatDateLocal(this.state.startDate)}</td>
                            </tr>
                            <tr>
                                <th className="ss-col-time col-center">Arrival Time</th>
                                <th className="ss-col-name">Patient's Name</th>
                                <th className="ss-col-procedure">Procedure</th>
                                <th className="ss-col-surgeon">Surgeon</th>
                                {/*<th className="ss-col-time col-center">Start Time</th>*/}
                                <th className="ss-col-phone">Phone Number</th>
                                <th className="ss-col-notes">Notes</th>
                            </tr>
                        </thead>
                        {this.renderTableBody(this.state.operations)}
                    </table>
                </div>
            </div>
        );
    }

    private async loadData() {
        try {
            const parameters = [
                "mode=verbose",
                `before=${this.state.endDate.toISO()}`,
                `after=${this.state.startDate.toISO()}`
            ];

            if (this.state.location) {
                parameters.push(`location=${this.state.location}`);
            }
            if (this.state.status) {
                parameters.push(`status=${this.state.status}`);
            }
            if (this.state.type) {
                parameters.push(`type=${this.state.type}`);
            }

            const items = await V2.get<any[]>(`surgery/summary?${parameters.join("&")}`);
            const extras = Array.from(new Array(Math.max(20 - items.length, 0))).map((a, i) => null);

            this.setState({
                isLoading: false,

                operations: items.concat(extras),
            });

            window.setTimeout(() => {
                window.print();
                window.close();
            }, 1000);
        }
        catch (e) {
            this.setState({
                error: e.message
            });
        }
    }

    private renderSurgeryList(surgery: any) {
        let items = [surgery.primarySurgery.shortName];
        items = items.concat(surgery.primarySurgeryOptions.map((b: any) => (b.glossaryOption && (b.glossaryOption.shortName || b.glossaryOption.fullName)) || b.id));
        if (surgery.additionalSurgeries && surgery.additionalSurgeries.length > 0) {
            for (const item of surgery.additionalSurgeries) {
                items.push(item.surgery.shortName);
                for (const option of item.options) {
                    items.push((option.glossaryOption && (option.glossaryOption.shortName || option.glossaryOption.fullName)) || option.id)
                }
            }
        }

        return items.join(", ");
    }

    private handleMessage(e: MessageEvent) {
        if (e.data.action && e.data.action === "surgery_schedule_parameters") {
            // Receiving report parameters
            this.setState({
                endDate: DateTime.fromISO(e.data.before),
                startDate: DateTime.fromISO(e.data.after),

                location: e.data.location,
                status: e.data.status,
                type: e.data.type,
            }, () => this.loadData());
        }
    }

    private renderTableBody(operations: any[]) {
        return (
            <tbody>
                {
                    operations.map((a, i) => (
                        a !== null
                            ? <tr key={a.id}>
                                <td className="col-center">{formatTimeLocal(a.time, true)}</td>
                                <td className="">{formatName(a.patient.name)}</td>
                                <td className="wrap">{this.renderSurgeryList(a)}</td>
                                <td className="">{formatName(a.primarySurgeon.name)}</td>
                                {/*<td className="">{""}</td>*/}
                                <td className="col-center">{formatPhone(a.patient.phone)}</td>
                                <td className="ss-col-notes">{a.patient.insuranceProvider}</td>
                            </tr>
                            : <tr key={i}>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                                {/*<td />*/}
                                <td />
                            </tr>
                    ))
                }
            </tbody>
        );
    }
}

export default SurgeryDayScheduleView;
